//src/assets/scripts/top/page.js
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

import Swiper from 'swiper';
import 'swiper/css';
import "swiper/css/scrollbar";
import { Autoplay, Scrollbar, Mousewheel, Navigation, FreeMode } from "swiper/modules";

export default class PageJS {
    constructor(common) {
        this.common = common;
        this.BREAK_SP = 767;
    }

    mq(type = "sp") {
        if (type === "sp") return `(max-width: ${this.BREAK_SP}px)`;
        if (type === "pc") return `(min-width: ${this.BREAK_SP + 1}px)`;
        return type;
    }

    init() {
        this._secAbout();
        this._secAboutPc();
        this._secFacilitySwiper();

        this.common.init();//common.jsはここでinitさせる
    }

    getAssetPath(relative) {
        const hostname = window.location.hostname;
        const isLocal =
            hostname === 'localhost' ||
            hostname === '127.0.0.1' ||
            hostname.endsWith('.local');
        if (isLocal) {
            return `/dist/assets/images/${relative}`;
        } else {
            return `/wp/wp-content/themes/theme-villamom/dist/assets/images/${relative}`;
        }
    }

    _secAbout_BK() {

        const about = document.querySelector("#About_area");
        if (!about) return;

        if (this._aboutMM) this._aboutMM.revert();
        this._aboutMM = gsap.matchMedia();

        this._aboutMM.add(this.mq("sp"), () => {

            const txt = about.querySelector(".txt_area");
            const txt_in = about.querySelector(".txt_area .in");

            const getMove = () => {
                return txt.scrollHeight - window.innerHeight;
            };

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: about,
                    start: "top top",
                    end: () => "+=" + getMove(),
                    scrub: true,
                    pin: true,
                    anticipatePin: 1,
                    invalidateOnRefresh: true
                }
            });

            tl.to(txt_in, {
                y: () => -getMove(),
                ease: "none"
            });

            return () => {
                tl.scrollTrigger.kill();
                tl.kill();
            };
        });
    }
    _secAboutPc_BK() {
        const about = document.querySelector("#About_area");
        if (!about) return;

        if (this._aboutMM) this._aboutMM.revert();
        this._aboutMM = gsap.matchMedia();

        this._aboutMM.add(this.mq("pc"), () => {

            //PC
                const experTl_01 = gsap.timeline({
                    scrollTrigger: {
                        //trigger: "#About_area .contents01",
                        trigger: "#About_area",
                        start: "top top",
                        end: "bottom bottom",
                        //end: () => "+=" + endHeight,
                        //end: () => "+=" + (window.innerHeight * 4),
                        //pin: true,
                        //markers: true,
                        scrub: true,

                    },
                });

                experTl_01
                    .to("#About_area .img_area .img1", {
                        duration: 1.2,
                        clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                        ease: "power1.inOut",
                    })
                    .to("#About_area .img_area .img2", {
                        duration: 1,
                        clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                        ease: "power1.inOut",
                    })
                   
                    .to("#About_area .img_area .img3", {
                        duration: 1,
                        clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                        ease: "power1.inOut",
                    })
                    ;
        });
    }

    _secAbout_BK() {
        const about = document.querySelector("#About_area");
        if (!about) return;

        if (this._aboutSpMM) this._aboutSpMM.revert();
        this._aboutSpMM = gsap.matchMedia();

        this._aboutSpMM.add(this.mq("sp"), () => {
            const txt = about.querySelector(".txt_area");
            const txt_in = about.querySelector(".txt_area .in");
            if (!txt || !txt_in) return;

            const getMove = () => {
                return txt.scrollHeight - window.innerHeight;
            };

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: about,
                    start: "top top",
                    end: () => "+=" + getMove(),
                    scrub: true,
                    pin: true,
                    anticipatePin: 1,
                    invalidateOnRefresh: true
                }
            });

            tl.to(txt_in, {
                y: () => -getMove(),
                ease: "none"
            });

            return () => {
                tl.scrollTrigger?.kill();
                tl.kill();
            };
        });
    }

    _secAbout_BK2() {
    const about = document.querySelector("#About_area");
    if (!about) return;

    if (this._aboutSpMM) this._aboutSpMM.revert();
    this._aboutSpMM = gsap.matchMedia();

    this._aboutSpMM.add(this.mq("sp"), () => {
        const txt = about.querySelector(".txt_area");
        const txt_in = about.querySelector(".txt_area .in");
        const btn = about.querySelector(".btn");
        if (!txt || !txt_in || !btn) return;

        const getMove = () => {
            return Math.max(0, txt.scrollHeight - window.innerHeight);
        };

        const showBtn = () => {
            btn.classList.add("is-show");
        };

        const hideBtn = () => {
            btn.classList.remove("is-show");
        };

        // 初期状態
        hideBtn();

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: about,
                start: "top top",
                end: () => "+=" + getMove(),
                scrub: true,
                pin: true,
                anticipatePin: 1,
                invalidateOnRefresh: true,

                onEnter: () => showBtn(),
                onEnterBack: () => showBtn(),
                onLeave: () => hideBtn(),
                onLeaveBack: () => hideBtn(),
            }
        });

        tl.to(txt_in, {
            y: () => -getMove(),
            ease: "none"
        });

        return () => {
            hideBtn();
            tl.scrollTrigger?.kill();
            tl.kill();
        };
    });
}

    _secAbout() {
        const about = document.querySelector("#About_area");
        if (!about) return;

        if (this._aboutSpMM) this._aboutSpMM.revert();
        this._aboutSpMM = gsap.matchMedia();

        this._aboutSpMM.add(this.mq("sp"), () => {
            const txt = about.querySelector(".txt_area");
            const txt_in = about.querySelector(".txt_area .in");
            const imgArea = about.querySelector(".img_area.sp");
            const btn = about.querySelector(".btn");
            if (!txt || !txt_in || !imgArea || !btn) return;

            const getMove = () => {
                return Math.max(0, txt.scrollHeight - window.innerHeight);
            };

            const showBtn = () => btn.classList.add("is-show");
            const hideBtn = () => btn.classList.remove("is-show");

            hideBtn();

            gsap.set(txt, {
                autoAlpha: 0,
                y: 40
            });

            gsap.set(imgArea, {
                "--about-overlay-opacity": 0
            });

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: about,
                    start: "top top",
                    end: () => "+=" + (getMove() + window.innerHeight * 0.8),
                    scrub: 1,
                    pin: true,
                    anticipatePin: 1,
                    invalidateOnRefresh: true,

                    onEnter: () => showBtn(),
                    onEnterBack: () => showBtn(),
                    onLeave: () => hideBtn(),
                    onLeaveBack: () => hideBtn(),

                    onUpdate: (self) => {
                        if (self.progress >= 0.95) {
                            hideBtn();
                        } else {
                            showBtn();
                        }
                    }
                }
            });

            tl.to(txt, {
                    autoAlpha: 1,
                    y: 0,
                    duration: 0.25,
                    ease: "power2.out"
                }, 0)
                .to(imgArea, {
                    "--about-overlay-opacity": 0.4,
                    duration: 0.1,
                    ease: "none"
                }, 0)
                .to(txt_in, {
                    y: () => -getMove(),
                    ease: "none",
                    duration: 1
                }, 0);

            return () => {
                hideBtn();
                tl.scrollTrigger?.kill();
                tl.kill();
            };
        });
    }



    _secAboutPc_BK() {
        const about = document.querySelector("#About_area");
        if (!about) return;

        if (this._aboutPcMM) this._aboutPcMM.revert();
        this._aboutPcMM = gsap.matchMedia();

        this._aboutPcMM.add(this.mq("pc"), () => {
            const experTl_01 = gsap.timeline({
                scrollTrigger: {
                    trigger: "#About_area",
                    start: "top top",
                    end: "bottom bottom",
                    scrub: true,
                },
            });

            experTl_01
                .to("#About_area .img_area .img1", {
                    duration: 1.2,
                    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                    //ease: "power1.inOut",
                    ease: "none",
                })
                .to("#About_area .img_area .img2", {
                    duration: 1,
                    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                    //ease: "power1.inOut",
                    ease: "none",
                })
                .to("#About_area .img_area .img3", {
                    duration: 1,
                    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                    //ease: "power1.inOut",
                    ease: "none",
                });

            return () => {
                experTl_01.scrollTrigger?.kill();
                experTl_01.kill();
            };
        });
    }
    _secAboutPc() {
        const about = document.querySelector("#About_area");
        if (!about) return;

        if (this._aboutPcMM) this._aboutPcMM.revert();
        this._aboutPcMM = gsap.matchMedia();

        this._aboutPcMM.add(this.mq("pc"), () => {

            const txtArea = about.querySelector(".txt_area");
            const txtIn = about.querySelector(".txt_area .in");
            const imgArea = about.querySelector(".img_area");
            if (!txtArea || !txtIn || !imgArea) return;

            const getMove = () => {
                return Math.max(0, txtIn.scrollHeight - imgArea.offsetHeight);
            };

            const experTl_01 = gsap.timeline({
                scrollTrigger: {
                    trigger: "#About_area",
                    start: "top top",
                    //end: "bottom bottom",
                    end: () => "+=" + (window.innerHeight * 3),
                    //end: () => "+=" + getMove(),
                    scrub: true,
                    //markers: true,
                    pin: true,
                    
                },
            });


            experTl_01
                // テキストを少し上へ
                .to(txtIn, {
                    y: () => -getMove(),
                    ease: "none",
                    duration: 3
                }, 0)

                // img1 → img2
                .to("#About_area .img_area .img1", {
                    opacity: 0,
                    ease: "none",
                    duration: 1
                }, 0.3)
                .to("#About_area .img_area .img2", {
                    opacity: 1,
                    ease: "none",
                    duration: 1
                }, 0.3)

                // img2 → img3
                .to("#About_area .img_area .img2", {
                    opacity: 0,
                    ease: "none",
                    duration: 1
                }, 1.6)
                .to("#About_area .img_area .img3", {
                    opacity: 1,
                    ease: "none",
                    duration: 1,
                }, 1.6);


            return () => {
                experTl_01.scrollTrigger?.kill();
                experTl_01.kill();
                gsap.set("#About_area .txt_area", { clearProps: "transform" });
            };
        });
    }

    _secFacilitySwiper() {

        const mq = window.matchMedia(this.mq("pc"));
        if (!mq.matches) return;

        const el = document.querySelector(".facility_swiper01");
        const el2 = document.querySelector(".facility_swiper02");
        const el3 = document.querySelector(".facility_swiper03");
        const el4 = document.querySelector(".facility_swiper04");

        if (!el) return;

        const opt = {
            modules: [Autoplay],
            loop: true,
            slidesPerView: "auto",
            speed: 16000,
            autoplay: {
                delay: 0,
            },
        };

        new Swiper(el, opt);
        new Swiper(el2, opt);
        new Swiper(el3, opt);
        new Swiper(el4, opt);
    }
}